<div class="insurance-coverage-form">
    <div class="insurance-coverage-form__title">
        <h3>Wijzig dekking</h3>
    </div>
    <form [formGroup]="form" (ngSubmit)="onSubmit()">
        <ins-insurance-coverage-control
            [purchasedProduct]="purchasedProduct"
            [relation]="relation"
            formControlName="coverageIds"
        ></ins-insurance-coverage-control>
        <div class="insurance-coverage-form__start-date">
            <wuc-form-field>
                <wuc-form-field-label>Ingangsdatum</wuc-form-field-label>
                <wuc-input-date-picker formControlName="startDate" [minDate]="minimumDate"></wuc-input-date-picker>
                <wuc-input-alert *ngIf="startDate.invalid && startDate.touched"
                                 [messages]="['Vul uw ingangsdatum in.']"></wuc-input-alert>
                <wuc-form-field-subtext *ngIf="errors?.length > 0">
                    <wuc-balloon backgroundStyle="secondary" arrowPosition="topLeft" padding="medium" [hasCloseIcon]="false" [isFullWidth]="true">
                        <wuc-list icon="cross">
                            <ng-container *ngFor="let error of errors">
                                <wuc-list-item>{{ error.message }}</wuc-list-item>
                            </ng-container>
                        </wuc-list>
                    </wuc-balloon>
                </wuc-form-field-subtext>
            </wuc-form-field>
            <wuc-form-field>
                <wuc-form-field-label></wuc-form-field-label>
                <wuc-button [isSubmitButton]="true" [isFullWidth]="true" [disabled]="isDisabled">Bevestig</wuc-button>
            </wuc-form-field>
        </div>
    </form>
</div>
